import { ChevronUpDownOutline, ChevronUpDownAscendingOutline, ChevronUpDownDescendingOutline } from '@olist/design-system-icons';

var _a, _b, _c;
var UNORDERED = 'UNORDERED';
var ASCENDING = 'ASC';
var DESCENDING = 'DESC';
var NONE = 'none';
var ARIA_ASC = 'ascending';
var ARIA_DESC = 'descending';
var ARIA_UNORDERED = 'none';
var orderingMap = (_a = {},
    _a[UNORDERED] = ASCENDING,
    _a[ASCENDING] = DESCENDING,
    _a[DESCENDING] = ASCENDING,
    _a);
var orderIconMap = (_b = {},
    _b[UNORDERED] = ChevronUpDownOutline,
    _b[ASCENDING] = ChevronUpDownAscendingOutline,
    _b[DESCENDING] = ChevronUpDownDescendingOutline,
    _b[NONE] = function () { return null; },
    _b);
var ariaSortMap = (_c = {},
    _c[ASCENDING] = ARIA_ASC,
    _c[DESCENDING] = ARIA_DESC,
    _c[UNORDERED] = ARIA_UNORDERED,
    _c);

export { ARIA_ASC, ARIA_DESC, ARIA_UNORDERED, ASCENDING, DESCENDING, NONE, UNORDERED, ariaSortMap, orderIconMap, orderingMap };
